import { TextField } from "@mui/material";

export const ReadOnlyField = ({
  label,
  value,
  Icon,
  isMobile,
  className = "",
}: {
  label: string;
  value: any;
  Icon: any;
  isMobile?: boolean;
  className?: string;
}) => {
  return (
    <div className={`awnCommon ${className}`}>
      <div className="flex trackinglist">
        <figure className="bg-yellow-50 w-[35px] h-[35px] rounded-full border border-yellow-200 p-1 flex justify-center items-center">
          <Icon className="text-yellow-400" />
        </figure>

        <aside className="ml-2 w-full min-w-0">
          <TextField
            label={label}
            value={value || ""}
            InputLabelProps={{ shrink: true }}
            fullWidth
            slotProps={{
              input: {
                readOnly: true,
              },
            }}
            sx={{
              width:"113%"
            }}
          />
        </aside>
      </div>
    </div>
  );
};